import AHttpService from '../a-http-service/a-http-service';
import URLS from '../../../shared/urls/urls';

class PopupService extends AHttpService {
  async getUserForPopup(userSlug) {
    const url = URLS.api.profilePopup.replace('<user-slug>', userSlug);

    const response = await this._http.get(url);
    return response.data;
  }
}

export default new PopupService();
